<template>
  <div>
    <base-header class="pb-9" type="danger"> </base-header>
    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header">
              <div class="h3 mb-0">Find Match IDs</div>
            </div>
            <div class="card-body mb--4">
              <div class="row align-items-center">
                <div class="col-4">
                  <base-input class="select-danger">
                    <el-select
                      v-model="filters"
                      filterable
                      multiple

                      placeholder="Add filters"
                    >
                      <el-option
                        v-for="option in filterOptionArray"
                        class="select-danger"
                        :key="option.field"
                        :label="option.label"
                        :value="option.field"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-4" v-for="filter in filters" :key="filter">
                  <filter-selector
                    :selection="filterOptions[filter]"
                    @valueChange="filterValues[filter] = $event"
                  >
                  </filter-selector>
                </div>
                <div class="col-auto" v-if="filters.length > 0">
                  <base-input>
                    <base-button @click="runQuery">Fetch</base-button>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <!-- <div class="card">
            <div class="card-body">
              <ul class="list-group list-group-flush list event-list">
                <li
                  v-for="match in matches"
                  class="list-group-item px-0"
                  :key="match.id"
                >
                  <match :match="match" />
                </li>
              </ul>
            </div>
          </div> -->

          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <el-table
              class="matchesTable"
              :data="matches"
              row-key="id"
              header-row-class-name="thead-light"
                  :default-sort = "{prop: 'startDate', order: 'descending'}"
            >
              <el-table-column
                label="Home"
          
                prop="team1Name"
                
              >
              </el-table-column>
              <el-table-column
                label="Away"
         
                prop="team2Name"
                
              >
              </el-table-column>
              <el-table-column
                label="Date"

                prop="startDate"
                sortable
              >
                <template v-slot="{ row }">
                  {{ row.startDate | date }}
                </template>
              </el-table-column>
              <el-table-column
                label="venue"
       
                prop="ground"
                
              >
                <template v-slot="{ row }">
            <venue-look-up :venueID="row.ground"></venue-look-up>
                </template>
              </el-table-column>
                        <el-table-column label="Comp Stage" prop="competition" sortable>
              </el-table-column>

              <el-table-column
                label="Ellipse ID"
     
                prop="ellipseMatchId"
                
              >
              </el-table-column>
              <el-table-column label="PulseID" prop="pulseID">
                <template v-slot="{ row }">
                  <base-input
                    type="number"
                    v-model="row.pulseID"
                    @input="pulseID($event, row.id)"
                  >
                  </base-input>
                </template>
              </el-table-column>
              <el-table-column
                label="Catch-Up HLS"
              >
                <template v-slot="{ row }">
                  <base-switch v-model="row.catchupBC" @input="catchUpSetup($event, row)"/>
                  <a v-if="row.catchupBCId" target="_blank" :href="`https://studio.brightcove.com/products/videocloud/media/video-details/${row.catchupBCId}/overview`">{{ row.catchupBCId }}</a>
                
                </template>
              </el-table-column>
            
            </el-table>

            <div
              slot="footer"
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <div class="">
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
                <base-button
                  v-if="matches.length > 0"
                  class="mt-2"
                  type="success"
                  @click="exportCsv"
                >
                  Export CSV
                </base-button>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </base-pagination>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MatchCardTable from "./Components/MatchCardTable";
import FilterSelector from "./Components/FilterSelector";
import VenueLookUp from "./Components/VenueLookUp";
import { Firebase } from "@/firebase.js";
import * as XLSX from "xlsx";
import moment from "moment";
export default {
  data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      filters: [],
      filterValues: {},
      filterOptions: {
        // startDate: { field: "startDate", label: "Match Start", type: "date-range" },
        year: {
          field: "year",
          label: "Year",
          type: "number",
        },
        cricketFormat: {
          field: "cricketFormat",
          label: "Format",
          collection: "matchFormats",
          collectionLabel: "name",
          collectionGetter: "formats",
          type: "single-select",
        },
        cricketType: {
          field: "cricketType",
          label: "Type",
          collection: "matchFormats",
          collectionLabel: "name",
          collectionGetter: "types",
          type: "single-select",
        },
        int: {
          field: "int",
          label: "International",
          type: "boolean",
        },
        teamsMap: {
          field: "teamsMap",
          collection: "teams",
          collectionLabel: "teamName",
          label: "Teams",
          type: "multi-select",
        },
        venue: {
          field: "venue",
          collection: "venues",
          collectionLabel: "name",
          label: "Venue",
          type: "single-select",
        },
      },
    };
  },
  components: {
    match: MatchCardTable,
        "venue-look-up": VenueLookUp,
    "filter-selector": FilterSelector,
  },
  computed: {
    config() {
      return this.$store.getters["config/config"];
    },
    loading() {
      return this.$store.getters["user/loading"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    matches() {
      return this.$store.getters["matches/array"];
    },
    matchFormats() {
      return this.$store.getters["matchFormats/formats"];
    },
    matchTypes() {
      return this.$store.getters["matchFormats/types"];
    },
    filterOptionArray() {
      return Object.values(this.filterOptions);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.matches.length;
    },
  },
  beforeMount() {
    this.$store.dispatch("teams/fetchAndAdd", {
        clauses: { where, limit: 0 },
      });
    this.$store.dispatch("venues/fetchAndAdd");
    // this.$store.dispatch("matchFormats/fetchAndAdd");


      let now = new Date();
      now.setDate(now.getDate() + 1)
      let year = now.getFullYear();
      let where = [
        ["year", "==", year],
        ["startDate", "<=", now],
      ];
      const orderBy = ['startDate', 'desc']
      this.$store.dispatch("matches/fetchAndAdd", {
        clauses: { where, limit: 650 },
      });
      // this.runQuery(false)

  },
  methods: {
    catchUpSetup(value, row){
if (value) {
      let payload = {}
      payload.name = `${row.team1Name} vs ${row.team2Name} - Catch-Up Higlights`
      var publish = Firebase.app()
        .functions("europe-west2")
        .httpsCallable("bcCMSCreate");
      publish(payload).then((result) => {
        console.log(result)
        this.$store.dispatch("matches/patch", { id: row.id, catchupBC: true, catchupBCId: result.data });
      });
    } else {
      this.$store.dispatch("matches/patch", { id: row.id, catchupBC: false });
    }
    },
    pulseID(value, id) {
      console.log(value);
      console.log(id);
      this.$store.dispatch("matches/patch", { id: id, pulseID: value });
    },
    runQuery() {
      this.$store.commit("matches/RESET_VUEX_EASY_FIRESTORE_STATE");
      let filters = this.filters;
      let where = [];
      filters.forEach((field) => {

          // check to make sure the filter has a value
          const value = this.filterValues[field];
          const option = this.filterOptions[field];
          if (option.type === "single-select" || option.type === 'boolean') {

            where.push([field, "==", value]);
          } else if (option.type === "multi-select") {
            value.forEach((v) => {
              where.push([`${field}.${v}`, "==", true]);
            });
          } else if (option.type === "number") {
            const date1 = parseInt(value)
            where.push([field, "==", date1]);
          }
      });

      this.$store.dispatch("matches/fetchAndAdd", {
        clauses: { where, limit: 250 },
      });
    },
    venueName(groundId) {
      if (!groundId) return "";
      const venue = this.$store.getters["venues/byId"](groundId);
      return (venue && venue.name) ? venue.name : groundId;
    },
    formatDate(startDate) {
      if (!startDate) return "";
      return moment(startDate).format("D MMMM YYYY");
    },
    exportCsv() {
      if (this.matches.length === 0) {
        this.$notify({
          type: "warning",
          title: "No Data",
          message: "There are no matches to export.",
        });
        return;
      }

      try {
        const exportData = this.matches.map((match) => ({
          Home: match.team1Name || "",
          Away: match.team2Name || "",
          Date: this.formatDate(match.startDate),
          Venue: this.venueName(match.ground),
          "Comp Stage": match.competition || "",
          "Ellipse ID": match.ellipseMatchId || "",
          PulseID: match.pulseID || "",
          "Catch-Up HLS": match.catchupBC ? "Yes" : "No",
          "Catch-Up BC ID": match.catchupBCId || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Matches");

        const fileName = `match_export_${new Date().toISOString().split("T")[0]}.csv`;
        XLSX.writeFile(workbook, fileName, { bookType: "csv" });

        this.$notify({
          type: "success",
          title: "Export Successful",
          message: `${exportData.length} matches exported to ${fileName}`,
        });
      } catch (error) {
        console.error("Error exporting data:", error);
        this.$notify({
          type: "error",
          title: "Export Error",
          message: "An error occurred while exporting data: " + error.message,
        });
      }
    },
  },
};
</script>

<style>
.el-table__expand-column {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.select-danger .el-select .el-tag {
  background: #f5365c;
}
</style>
